<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="tw-justify-start tw-items-center tw-my-8">
            <label for="project"> عرض في الموقع </label>
            <input
              type="checkbox"
              class="form-check-input"
              name="category"
              id="project"
              value="true"
              v-model="data.is_active"
            />
          </div>
          <div class="row justify-content-between product">
            <v-expansion-panels>
              <!-- ======= Start Project Main Section =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>البيانات الاساسية للمشروع</h5>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="col-8 mx-auto">
                        <uplode-image
                          :data_src="data.image_ar"
                          @inputChanged="uploadMainImageSectionAr($event)"
                          placeHolder=" أضف صورة للسكشن الاساسي (عربي)"
                        ></uplode-image>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="col-8 mx-auto">
                        <uplode-image
                          :data_src="data.image"
                          @inputChanged="uploadMainImageSection($event)"
                          placeHolder=" أضف صورة للسكشن الاساسي (أنجليزي)"
                        ></uplode-image>
                      </div>
                    </div>
                    <!-- Project Name Input -->
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isArabic"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.name_ar"
                        />
                        <label for="name_input" class="form-label"
                          >اسم المشروع(عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.name_en"
                        />
                        <label for="name_input" class="form-label"
                          >اسم المشروع(انجليزي )</label
                        >
                      </div>
                    </div>
                    <!-- <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.title_ar"
                          @keypress="isArabic"
                        />
                        <label for="name_input" class="form-label"
                          >فئة المشروع(عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="data.title_en"
                          @keypress="isEnglish"
                        />
                        <label for="name_input" class="form-label"
                          >فئة المشروع(انجليزي )</label
                        >
                      </div>
                    </div> -->
                    <!-- Project region Input -->
                    <div class="col-lg-12 py-0">
                      <div class="col-6 me-auto">
                        <uplode-image
                          :data_src="data.flag"
                          @inputChanged="uploadFlagImage($event)"
                          placeHolder=" أضف صورة لعلم الدولة  "
                        ></uplode-image>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isArabic"
                          v-model.trim="data.location_ar"
                        />
                        <label for="name_input" class="form-label"
                          >دولة المشروع(عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.location_en"
                        />
                        <label for="name_input" class="form-label"
                          >دولة المشروع(انجليزي )</label
                        >
                      </div>
                    </div>
                    <!-- Project Download Number Input -->
                    <div class="col-lg-4 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.downloads"
                        />
                        <label for="name_input" class="form-label">
                          عدد مرات تحميل المشروع
                        </label>
                      </div>
                    </div>

                    <!-- Project Platforms Input -->
                    <div class="col-lg-4 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="data.platforms_ar"
                          @keypress="isArabic"
                        />
                        <label for="name_input" class="form-label"
                          >المنصات (عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-4 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="data.platforms_en"
                          @keypress="isEnglish"
                        />
                        <label for="name_input" class="form-label"
                          >المنصات (انجليزي)</label
                        >
                      </div>
                    </div>

                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >نبذة مختصرة عن المشروع(عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isArabic"
                          v-model="data.description_ar"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >نبذة مختصرة عن المشروع(انجليزي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isEnglish"
                          v-model="data.description_en"
                        ></textarea>
                      </div>
                    </div>
                    <!-- Project Ratting Number Input -->
                    <div class="col-lg-4 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.ratings"
                        />
                        <label for="name_input" class="form-label">
                          تقيم المشروع
                        </label>
                      </div>
                    </div>
                    <!-- Project description Input -->
                    <!-- Project colors Inputs -->
                    <span
                      >لاحظ ان االالوان الثلاث الاولة خاصة بعرض المشروع في
                      الصفحة الرئيسية
                    </span>
                    <div
                      class="col-lg-4 py-0"
                      v-for="(background, index) in data.backgrounds"
                      :key="index"
                    >
                      <div class="input_wrapper top_label">
                        <input
                          type="color"
                          class="form-control"
                          v-model.trim="background.bg"
                        />
                        <label
                          for="name_input"
                          class="form-label"
                          v-if="index == 0"
                          >اللون الاول</label
                        >
                        <label
                          for="name_input"
                          class="form-label"
                          v-if="index == 1"
                          >اللون الثاني</label
                        >
                        <label
                          for="name_input"
                          class="form-label"
                          v-if="index == 2"
                          >اللون الثالث</label
                        >
                      </div>
                    </div>
                    <!-- Project Download Number Input -->
                    <div class="col-lg-6 py-0 mx-auto">
                      <!-- START:: DATE PICKER INPUT -->
                      <div class="input_wrapper top_label date_input">
                        <label class="form-label">سنة الانشاء</label>
                        <multiselect
                          v-model="data.founded_in"
                          :options="manufactruingYears"
                          label="name"
                          track-by="id"
                          placeholder=""
                          :searchable="true"
                          :allow-empty="true"
                          :show-labels="false"
                        >
                          <template slot="option" slot-scope="props">
                            <!-- <img
                                      class="option__image"
                                      :src="props.option.image"
                                    /> -->
                            <span class="option__title">
                              {{ props.option.name }}
                            </span>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                    <!-- Project ordering Number Input -->
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.ordering"
                        />
                        <label for="name_input" class="form-label">
                          ترتيب المشروع
                        </label>
                      </div>
                    </div>
                    <!-- Project ordering Input -->
                  </div>
                  <!-- Project colors Inputs -->
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End Project Main Section =======  -->

              <!-- ======= Start  What is Project Section =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>ماهو المشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="col-8 mx-auto">
                        <uplode-image
                          :data_src="data.about_image_ar"
                          @inputChanged="uploadAboutImageSectionAr($event)"
                          placeHolder=" صورة للمشروع (عربي) "
                        ></uplode-image>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="col-8 mx-auto">
                        <uplode-image
                          :data_src="data.about_image"
                          @inputChanged="uploadAboutImageSection($event)"
                          placeHolder=" صورة للمشروع (أنجليزي) "
                        ></uplode-image>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >ماهو المشروع(عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isArabic"
                          v-model="data.about_project_ar"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >ماهو المشروع(انجليزي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isEnglish"
                          v-model="data.about_project_en"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End What is Project Sections =======  -->

              <!-- ======= Start  main Features Section =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>الجزء الخاص بمميزات المشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          @keypress="isArabic"
                          v-model.trim="data.feature_title_ar"
                        />
                        <label for="name_input" class="form-label"
                          >عنوان السكشن (عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @keypress="isEnglish"
                          v-model.trim="data.feature_title_en"
                        />
                        <label for="name_input" class="form-label"
                          >عنوان السكشن (انجليزي )</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label">
                          الوصف(عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isArabic"
                          v-model="data.feature_description_ar"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >الوصف (انجليزي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          @keypress="isEnglish"
                          v-model="data.feature_description_en"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <h3>اضف بعض الصور للمشروع</h3>
                      <span>(يجب ان يكون عدد الصور 3)</span>
                      <div>
                        <span>(عربي)</span>
                        <uplode-multiple
                          @inputChanged="
                            images_uploded($event, 'feature_images_ar')
                          "
                          :data_src="data.feature_images_ar"
                          category="feature_images_ar"
                        ></uplode-multiple>
                      </div>
                      <span>(أنجليزي)</span>
                      <uplode-multiple
                        @inputChanged="images_uploded($event, 'feature_images')"
                        :data_src="data.feature_images"
                        category="feature_images"
                      ></uplode-multiple>
                    </div>
                    <!-- </div> -->
                    <h3>أضف مميزات للمشروع</h3>
                    <div class="col-10 row">
                      <div
                        class="col-lg-6"
                        v-for="(feature, index) in data.main_features"
                        :key="index"
                      >
                        <div class="col-lg-12 py-0">
                          <uplode-image
                            :data_src="feature.icon"
                            @inputChanged="uploadMainFeatures($event, index)"
                            placeHolder="أضف icon   "
                          ></uplode-image>
                        </div>
                        <div class="col-lg-12 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @keypress="isArabic"
                              v-model.trim="feature.title_ar"
                            />
                            <label for="name_input" class="form-label"
                              >الميزة (عربي )</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-12 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              @keypress="isEnglish"
                              v-model.trim="feature.title_en"
                            />
                            <label for="name_input" class="form-label"
                              >الميزة ( انجليزي)</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Actions -->
                    <div
                      class="col-1 py-0"
                      v-if="data.main_features.length > 0"
                    >
                      <span class="append" @click="appendMainFeature()">
                        <i class="fas fa-plus-circle"></i>
                      </span>
                    </div>
                    <div
                      class="col-1 py-0"
                      v-show="data.main_features.length > 1"
                    >
                      <span class="append" @click="deleteMainFeature()">
                        <i class="fas fa-minus-circle"></i>
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End main Features Sections =======  -->

              <!-- ======= Start Splash Sections =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>الصور المتحركة للمشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <h5>السكشن الاول</h5>
                    <span>(يجب ان يكون عدد الصور 3)</span>
                    <span>(عربي)</span>
                    <div class="col-lg-12 py-0 row">
                      <uplode-multiple
                        @inputChanged="
                          images_uploded($event, 'first_splashes_ar')
                        "
                        :data_src="data.first_splashes_ar"
                        category="first_splashes_ar"
                      ></uplode-multiple>
                    </div>
                    <span>(أنجليزي)</span>
                    <div class="col-lg-12 py-0 row">
                      <uplode-multiple
                        @inputChanged="images_uploded($event, 'first_splashes')"
                        :data_src="data.first_splashes"
                        category="first_splashes"
                      ></uplode-multiple>
                    </div>
                    <!-- Change Here -->
                    <h5>السكشن الثاني</h5>
                    <span>(يجب ان يكون عدد الصور 3)</span>
                    <span>(عربي)</span>
                    <div class="col-lg-12 py-0 row">
                      <uplode-multiple
                        @inputChanged="
                          images_uploded($event, 'second_splashes_ar')
                        "
                        :data_src="data.second_splashes_ar"
                        category="second_splashes_ar"
                      ></uplode-multiple>
                    </div>
                    <span>(أنجليزي)</span>
                    <div class="col-lg-12 py-0 row">
                      <uplode-multiple
                        @inputChanged="
                          images_uploded($event, 'second_splashes')
                        "
                        :data_src="data.second_splashes"
                        category="second_splashes"
                      ></uplode-multiple>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= Start  Splash Sections =======  -->

              <!-- ======= Start  Project Provide Sections =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>ماذا فعلنا في المشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="name_input" class="form-label">
                          اشرح ماذا فعلنا (عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="data.project_done_description_ar"
                          @keypress="isArabic"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="name_input" class="form-label"
                          >اشرح ماذا فعلنا (انجليزي )</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="data.project_done_description_en"
                          @keypress="isEnglish"
                        ></textarea>
                      </div>
                    </div>
                    <h3>اضف بعض صور المشروع</h3>
                    <span>(يجب ان يكون عدد الصور 4)</span>
                    <span>(عربي)</span>
                    <div class="col-lg-12 py-0 row">
                      <uplode-multiple
                        @inputChanged="images_uploded($event, 'done_images_ar')"
                        :data_src="data.project_done_images_ar"
                        :lengthNumber="3"
                        category="done_images_ar"
                      ></uplode-multiple>
                    </div>
                    <span>(أنجليزي)</span>
                    <div class="col-lg-12 py-0 row">
                      <uplode-multiple
                        @inputChanged="images_uploded($event, 'done_images')"
                        :data_src="data.project_done_images"
                        :lengthNumber="3"
                        category="done_images"
                      ></uplode-multiple>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End What we Did Sections =======  -->
              <!-- ======= Start What we Provide Sections =======  -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>ماذا يقدم المشروع</h5>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <div class="row">
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="data.project_provide_title_ar"
                          @keypress="isArabic"
                        />
                        <label for="name_input" class="form-label"
                          >عنوان السكشن (عربي)</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="data.project_provide_title_en"
                          @keypress="isEnglish"
                        />
                        <label for="name_input" class="form-label"
                          >عنوان السكشن (انجليزي )</label
                        >
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label">
                          المحتوي(عربي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="data.project_provide_description_ar"
                          @keypress="isArabic"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-lg-6 py-0">
                      <div class="input_wrapper top_label">
                        <label for="textarea_1" class="form-label"
                          >المحتوي (انجليزي)</label
                        >
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="data.project_provide_description_en"
                          @keypress="isEnglish"
                        ></textarea>
                      </div>
                    </div>
                    <div class="">
                      <h3>اضف بعض الصور للمشروع</h3>
                      <span>(يجب ان يكون عدد الصور 3)</span>
                      <span>(عربي)</span>
                      <div class="col-12">
                        <uplode-multiple
                          @inputChanged="
                            images_uploded($event, 'provide_images_ar')
                          "
                          :data_src="data.project_provide_images_ar"
                          category="provide_images_ar"
                        ></uplode-multiple>
                      </div>
                      <span>(أنجليزي)</span>
                      <uplode-multiple
                        @inputChanged="images_uploded($event, 'provide_images')"
                        :data_src="data.project_provide_images"
                        category="provide_images"
                      ></uplode-multiple>
                    </div>
                    <h3>المميزات</h3>
                    <div class="col-10 row">
                      <div
                        class="col-lg-6"
                        v-for="(feature,
                        index) in data.project_provide_features"
                        :key="index"
                      >
                        <div class="col-lg-12 py-0">
                          <uplode-image
                            :data_src="feature.icon"
                            @inputChanged="
                              uploadWhatProjectProvideFeatures($event, index)
                            "
                            placeHolder="أضف icon   "
                          ></uplode-image>
                        </div>
                        <div class="col-lg-12 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="feature.title_ar"
                              @keypress="isArabic"
                            />
                            <label for="name_input" class="form-label"
                              >الميزة (عربي )</label
                            >
                          </div>
                        </div>
                        <div class="col-lg-12 py-0">
                          <div class="input_wrapper top_label">
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="feature.title_en"
                              @keypress="isEnglish"
                            />
                            <label for="name_input" class="form-label"
                              >الميزة ( انجليزي)</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Actions -->
                    <div
                      class="col-1 py-0"
                      v-if="data.project_provide_features.length > 0"
                    >
                      <span
                        class="append"
                        @click="appendProjectProvideFeature()"
                      >
                        <i class="fas fa-plus-circle"></i>
                      </span>
                    </div>
                    <div
                      class="col-1 py-0"
                      v-show="data.project_provide_features.length > 1"
                    >
                      <span
                        class="append"
                        @click="deleteProjectProvideFeature()"
                      >
                        <i class="fas fa-minus-circle"></i>
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- ======= End main Features Sections =======  -->
            </v-expansion-panels>

            <!--Start  Project Tools Inputs -->

            <div class="tw-mt-8 tw-w-full">
              <div class="input_wrapper">
                <label class="form-label">الادوات</label>
                <multiselect
                  v-model="data.tools"
                  :options="tools"
                  label="title"
                  track-by="id"
                  placeholder=""
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                  multiple
                >
                  <template slot="option" slot-scope="props">
                    <img class="option__image" :src="props.option.image" />
                    <span class="option__title">
                      {{ props.option.title }}
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="tw-mt-8 tw-w-full">
              <div class="input_wrapper">
                <label class="form-label">القسم</label>
                <multiselect
                  v-model="data.category"
                  :options="categories"
                  label="name"
                  track-by="id"
                  placeholder=""
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                >
                  <template slot="option" slot-scope="props">
                    <span class="option__title">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <!--End  Project Tools Inputs -->
        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",
  props: ["id"],
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.projects.title"),
          disabled: false,
          href: "/projects",
        },
        {
          text: this.$t("breadcrumb.projects.edit"),
          disabled: true,
          href: "",
        },
      ],
      backgrounds: [],
      // ========== Loading
      btnIsLoading: false,
      data: {
        image: null,
        category: null,
        image_ar: null,
        name_ar: null,
        name_en: null,
        title_ar: null,
        title_en: null,
        ordering: null,
        location_ar: null,
        location_en: null,
        downloads: null,
        is_active: null,
        flag: null,
        platforms_ar: null,
        platforms_en: null,
        description_ar: null,
        description_en: null,
        ratings: null,
        founded_in: null,
        // Background Colors
        backgrounds: [
          {
            bg: null,
          },
          {
            bg: null,
          },
          {
            bg: null,
          },
          {
            bg: null,
          },
          {
            bg: null,
          },
          {
            bg: null,
          },
        ],
        first_splashes: [],
        second_splashes: [],
        first_splashes_ar: [],
        second_splashes_ar: [],
        tools: [],
        // Start About Data
        about_image: null,
        about_image_ar: null,
        about_project_ar: null,
        about_project_en: null,
        // End About Data

        // Start  Features Section Data
        feature_description_en: null,
        feature_description_ar: null,
        feature_title_en: null,
        feature_title_ar: null,
        feature_images: [],
        feature_images_ar: [],
        main_features: [
          {
            icon: null,
            title_ar: null,
            title_en: null,
          },
        ],
        // End Features Section Data

        // Start What The Project Present
        project_done_images: [],
        project_done_images_ar: [],
        project_done_description_ar: null,
        project_done_description_en: null,
        // End What the Project Present

        // Start What The Project Provide
        project_provide_images: [],
        project_provide_images_ar: [],
        project_provide_title_en: null,
        project_provide_title_ar: null,
        project_provide_description_ar: null,
        project_provide_description_en: null,
        project_provide_features: [
          {
            icon: null,
            title_ar: null,
            title_en: null,
          },
        ],
        // End What The Project Provide
      },

      // =====All tools data
      tools: [],
      categories: [],
    };
  },

  computed: {
    manufactruingYears() {
      let max = new Date().getFullYear();
      let min = max - 30;
      let years = [];
      for (let i = max; i >= min; i--) {
        years.push({ id: i, name: i, value: i });
      }
      return years;
    },
  },

  methods: {
    // Upload main Project Image
    uploadMainImageSection(img) {
      this.data.image = img;
    },
    uploadMainImageSectionAr(img) {
      this.data.image_ar = img;
    },
    uploadAboutImageSectionAr(img) {
      this.data.about_image_ar = img;
    },
    // Upload about section Image
    uploadAboutImageSection(img) {
      this.data.about_image = img;
    },

    uploadFlagImage(img) {
      this.data.flag = img;
    },

    images_uploded(imgs, type) {
      console.log(type);
      if (type == "done_images" || type == "done_images_ar") {
        if (imgs.length == 4 || imgs.length < 4) {
          imgs.forEach((img) => {
            if (img.first) {
              if (img.img_file) {
                this.changeImage(img, type);
              }
            }
          });
        }
      } else {
        if (imgs.length == 3 || imgs.length < 3) {
          imgs.forEach((img) => {
            if (img.first) {
              if (img.img_file) {
                this.changeImage(img, type);
              }
            }
          });
        }
      }
    },
    spliceImage(emitData) {
      let categoryType = emitData.category;
      let deletedImage = emitData.id;
      // console.log(categoryType);
      // if (categoryType == "done_images") {
      //   deletedImage = this.data.project_done_images.filter((img) => {
      //     return img.id == emitData.id;
      //   });
      // }
      // if (categoryType == "provide_images") {
      //   deletedImage = this.data.project_provide_images.filter((img) => {
      //     return img.id == emitData.id;
      //   });
      //   return;
      // }
      // if (categoryType == "done_images_ar") {
      //   deletedImage = this.data.project_done_images_ar.filter((img) => {
      //     return img.id == emitData.id;
      //   });
      //   return;
      // }
      // if (categoryType == "provide_images_ar") {
      //   deletedImage = this.data.project_provide_images_ar.filter((img) => {
      //     return img.id == emitData.id;
      //   });
      //   return;
      // } else {
      //   deletedImage = this.data[emitData.category].filter((img) => {
      //     return img.id == emitData.id;
      //   });
      // }
      // console.log(deletedImage);
      this.axios
        .delete(`project/app_media/${emitData.id}`)
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
          if (categoryType == "done_images") {
            this.data.project_done_images = this.data.project_done_images.filter(
              (img) => {
                return img.id != deletedImage.id;
              }
            );
          } else if (categoryType == "provide_images") {
            this.data.project_provide_images = this.data.project_provide_images.filter(
              (img) => img.id != deletedImage.id
            );
            console.log(
              this.data.project_provide_images.filter(
                (img) => img.id != deletedImage.id
              )
            );
          }
          if (categoryType == "done_images_ar") {
            this.data.project_done_images_ar = this.data.project_done_images_ar.filter(
              (img) => {
                return img.id != deletedImage.id;
              }
            );
          } else if (categoryType == "provide_images_ar") {
            this.data.project_provide_images_ar = this.data.project_provide_images_ar.filter(
              (img) => {
                return img.id != deletedImage.id;
              }
            );
          } else {
            this.data[emitData.category] = this.data[emitData.category].filter(
              (img) => {
                return img.id != deletedImage.id;
              }
            );
          }
        })
        .catch(() => {});
    },

    // Start  upload what is this project  Image
    uploadwhatIsSection(obj) {
      this.whatIsSection.image = obj;
    },
    // End  upload what is this project  Image
    // Start  Project Provide Section
    uploadwhatProjectPresentSection(img, index) {
      this.data.project_provide_images[index].media = img;
      this.changeImage(img, "provide_images");
    },
    uploadWhatProjectProvideFeatures(img, index) {
      this.data.project_provide_features[index].icon = img;
    },
    appendProjectProvideFeature() {
      this.data.project_provide_features.push({
        icon: null,
        title_ar: null,
        title_en: null,
      });
    },
    deleteProjectProvideFeature() {
      let lastElement = this.data.project_provide_features[
        this.data.project_provide_features.length - 1
      ];
      if (lastElement.id) {
        // this.data.intro.features.splice(-1);
        this.axios({
          method: "DELETE",
          url: `feature/${lastElement.id}`,
        })
          .then(() => {
            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
            this.data.project_provide_features.splice(-1);
          })
          .catch((err) => {
            this.dialogDelete = false;
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });
      } else {
        this.data.project_provide_features.splice(-1);
      }
    },
    // End  Project Provide Section
    // Start  MainFeature Section
    uploadMainFeatures(img, index) {
      this.data.main_features[index].icon = img;
    },
    appendMainFeature() {
      this.data.main_features.push({
        icon: null,
        title_ar: null,
        title_en: null,
      });
    },
    deleteMainFeature() {
      // this.data.sections[index].features.splice(-1);
      let lastElement = this.data.main_features[
        this.data.main_features.length - 1
      ];
      if (lastElement.id) {
        // this.data.intro.features.splice(-1);
        this.axios({
          method: "DELETE",
          url: `feature/${lastElement.id}`,
        })
          .then(() => {
            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
            this.data.main_features.splice(-1);
          })
          .catch((err) => {
            this.dialogDelete = false;
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });
      } else {
        this.data.main_features.splice(-1);
      }
    },

    uploadFeatureImages(img, index) {
      this.data.feature_images[index] = img;
      this.changeImage(img, "feature_images");
      console.log(img);
    },
    deleteFeaturesImage() {},
    changeImage(img, type) {
      const formData = new FormData();
      formData.append("app_mediaable_id", this.id);
      formData.append("media", img.img_file);
      formData.append("option", type);
      formData.append("media_type", "image");
      this.axios({
        method: "POST",
        url: `project/app_media`,
        data: formData,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // End  MainFeature Section
    // deleteImage
    async deleteImage(imageID) {
      try {
        await this.axios({
          method: "DELETE",
          url: `project/app_media/${imageID}`,
        });
        this.$iziToast.success({
          timeout: 2000,
          message: this.$t("deleteSuccess"),
          position: "bottomRight",
        });
        this.getData();
        return true;
      } catch (err) {
        this.$iziToast.error({
          timeout: 2000,
          message: err.response.data.message,
          position: "bottomRight",
        });
        return false;
      }
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      let validate = false;
      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "الصورة في البيانات الاساسية مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.name_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  أسم المشروع  مطلوب (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.name_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  أسم المشروع  مطلوب (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
        // } else if (!this.data.title_ar) {
        //   this.$iziToast.error({
        //     timeout: 2000,
        //     message: "  فئة المشروع  مطلوبة (عربي ) ",
        //     position: "bottomRight",
        //   });
        //   this.btnIsLoading = false;
        //   return;
        // } else if (!this.data.title_en) {
        //   this.$iziToast.error({
        //     timeout: 2000,
        //     message: "  فئة المشروع  مطلوبة (أنجليزي ) ",
        //     position: "bottomRight",
        //   });
        //   this.btnIsLoading = false;
        //   return;
      } else if (!this.data.location_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  دولة المشروع  مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.location_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  دولة المشروع  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.downloads) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  عدد مرات  تحميل  المشروع  مطلوب ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.platforms_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  المنصات   مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.platforms_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  المنصات   مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ratings) {
        this.$iziToast.error({
          timeout: 2000,
          message: " تقيم المشروع  مطلوب  ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.ratings > 5 || this.data.ratings < 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: " تقيم المشروع يجب ان يكون من 0 الي 5   ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ordering) {
        this.$iziToast.error({
          timeout: 2000,
          message: " ترتيب المشروع مطلوب   ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.ordering < 1) {
        this.$iziToast.error({
          timeout: 2000,
          message: " ترتيب المشروع يجب ان يكون أكبر  من 0    ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  النبذة المختصرة  مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  النبذة المختصرة  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.category) {
        this.$iziToast.error({
          timeout: 2000,
          message: "القسم مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        if (validate) return;
        this.data.backgrounds.map((background, index) => {
          if (validate) return;
          if (!background.bg) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل اللون رقم ${index + 1}`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          }
        });
        if (!this.data.founded_in) {
          this.$iziToast.error({
            timeout: 2000,
            message: " سنة الانشاء مطلوبة",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.about_image) {
          this.$iziToast.error({
            timeout: 2000,
            message: " أَضف الصورة في سكشن ماهو المشروع",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.about_project_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  محتوي وصف المشروع في سكشن ماهو المشروع مطلوب (عربي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.about_project_en) {
          this.$iziToast.error({
            timeout: 2000,
            message:
              "  محتوي وصف المشروع في سكشن ماهو المشروع مطلوب (أنجليزي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_title_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  العنوان  في سكشن مميزات المشروع مطلوب (عربي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_title_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  العنوان  في سكشن مميزات المشروع مطلوب (أنجليزي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_description_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  الوصف  في سكشن مميزات المشروع مطلوب (عربي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.feature_description_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: "  الوصف  في سكشن مميزات المشروع مطلوب (أنجليزي ) ",
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
          // } else if( !this.data.feature_images[0]){
          //     this.$iziToast.error({
          //         timeout: 2000,
          //         message: `أدخل الصورة  رقم 1 في سكشن مميزات المشروع`,
          //         position: "bottomRight",
          //       });
          //       this.btnIsLoading = false;
          //       return;
          // }  else if( !this.data.feature_images[1]){
          //     this.$iziToast.error({
          //         timeout: 2000,
          //         message: `أدخل الصورة  رقم 2 في سكشن مميزات المشروع`,
          //         position: "bottomRight",
          //       });
          //       this.btnIsLoading = false;
          //       return;
          // }  else if( !this.data.feature_images[2]){
          //     this.$iziToast.error({
          //         timeout: 2000,
          //         message: `أدخل الصورة  رقم 3 في سكشن مميزات المشروع`,
          //         position: "bottomRight",
          //       });
          //       this.btnIsLoading = false;
          //       return;
        }
        this.data.main_features.map((features, index) => {
          if (validate) return;
          if (!features.icon) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل icon الميزة  رقم ${
                index + 1
              } في سكشن مميزات المشروع`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!features.title_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان الميزة رقم ${
                index + 1
              } في سكشن مميزات المشروع مطلوب (عربي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!features.title_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان الميزة رقم ${
                index + 1
              } في سكشن مميزات المشروع مطلوب (أنجليزي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          }
        });
        if (validate) return;
        // if( !this.data.first_splashes[0]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  1 في الجزء الاول من الصور المتحركة`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // } else if( !this.data.first_splashes[1]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم 2 في الجزء الاول من الصور المتحركة`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // }  else if( !this.data.first_splashes[2]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  3 في الجزء الاول من الصور المتحركة`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // } else if( !this.data.second_splashes[0]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  1 في الجزء الثاني من الصور المتحركة`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // } else if( !this.data.second_splashes[1]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم 2 في الجزء الثاني من الصور المتحركة`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // }  else if( !this.data.second_splashes[2]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  3 في الجزء الثاني من الصور المتحركة`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // }
        else if (!this.data.project_done_description_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  الوصف في سكشن ماذا فعلنا في المشروع مطلوب (عربي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_done_description_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  الوصف في سكشن ماذا فعلنا في المشروع مطلوب (أنجليزي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        }
        // else if( !this.data.project_done_images[0]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  1 في سكشن ماذا فعلنا في المشروع`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // } else if( !this.data.project_done_images[1]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم 2 في سكشن ماذا فعلنا في المشروع`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // }  else if( !this.data.project_done_images[2]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  3 في سكشن ماذا فعلنا في المشروع`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // }  else if( !this.data.project_done_images[3]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  4 في سكشن ماذا فعلنا في المشروع `,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // }
        else if (!this.data.project_provide_title_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  العنوان في سكشن ماذا يقدم المشروع مطلوب (عربي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_title_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  العنوان في سكشن ماذا يقدم المشروع مطلوب (أنجليزي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_description_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  الوصف في سكشن ماذا يقدم المشروع مطلوب (عربي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.project_provide_description_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: `  الوصف في سكشن ماذا يقدم المشروع مطلوب (أنجليزي)`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        }
        //  else if( !this.data.project_provide_images[0]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  1 في سكشن ماذا يقدم المشروع`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // } else if( !this.data.project_provide_images[1]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم 2 في سكشن ماذا يقدم المشروع`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // }  else if( !this.data.project_provide_images[2]){
        //     this.$iziToast.error({
        //         timeout: 2000,
        //         message: ` أضف الصورة رقم  3 في سكشن ماذا يقدم المشروع`,
        //         position: "bottomRight",
        //       });
        //       this.btnIsLoading = false;
        //       return;
        // }
        this.data.project_provide_features.map((features, index) => {
          if (validate) return;
          if (!features.icon) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل icon الميزة  رقم ${
                index + 1
              } في سكشن ماذا يقدم المشروع`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!features.title_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان الميزة رقم ${
                index + 1
              } في سكشن ماذا يقدم المشروع مطلوب (عربي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!features.title_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان الميزة رقم ${
                index + 1
              } في سكشن ماذا يقدم  المشروع مطلوب (أنجليزي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          }
        });
        if (validate) return;
        if (!this.data.tools.length) {
          this.$iziToast.error({
            timeout: 2000,
            message: `اختر ادوات`,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          return;
        } else {
          this.submitData();
          return;
        }
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      if (this.data.image_ar.img_file) {
        submit_data.append("image_ar", this.data.image_ar.img_file);
      }
      if (this.data.about_image_ar.img_file) {
        submit_data.append(`about_image_ar`, this.data.about_image_ar.img_file);
      }
      submit_data.append("ar[location]", this.data.location_ar);
      submit_data.append("en[location]", this.data.location_en);

      submit_data.append("ar[name]", this.data.name_ar);
      submit_data.append("en[name]", this.data.name_en);

      submit_data.append("is_active", +this.data.is_active);

      submit_data.append("ordering", this.data.ordering);

      // submit_data.append("ar[title]", this.data.title_ar);
      // submit_data.append("en[title]", this.data.title_en);

      submit_data.append("ar[platforms]", this.data.platforms_ar);
      submit_data.append("en[platforms]", this.data.platforms_en);

      submit_data.append("ar[description]", this.data.description_ar);
      submit_data.append("en[description]", this.data.description_en);

      submit_data.append("founded_in", this.data.founded_in.value);
      submit_data.append("category_id", this.data.category?.id || null);

      if (this.data.image.img_file) {
        submit_data.append("image", this.data.image.img_file);
      }
      submit_data.append("downloads", this.data.downloads);
      submit_data.append("ratings", this.data.ratings);

      this.data.backgrounds.forEach((item, index) => {
        submit_data.append(`backgrounds[${index}][bg]`, item.bg);
        if (index <= 2) {
          submit_data.append(`backgrounds[${index}][key]`, "index");
        } else {
          submit_data.append(`backgrounds[${index}][key]`, "show");
        }
      });

      // this.data.first_splashes.forEach((item, index) => {
      //     if( item.img_file){
      //     submit_data.append(`first_splashes[${index}]`, item.img_file)
      //   }
      // })

      // this.data.second_splashes.forEach((item, index) => {
      //     if( item.img_file){
      //         submit_data.append(`second_splashes[${index }]`, item.img_file)
      //         console.log(index,item.img_file)
      //     }
      // })

      this.data.tools.forEach((tool, index) => {
        submit_data.append(`tools[${index}]`, tool.id);
      });

      if (this.data.about_image.img_file) {
        submit_data.append(`about_image`, this.data.about_image.img_file);
      }
      if (this.data.flag.img_file) {
        submit_data.append(`flag`, this.data.flag.img_file);
      }

      submit_data.append(`ar[about_project]`, this.data.about_project_ar);

      submit_data.append(`en[about_project]`, this.data.about_project_en);

      submit_data.append(`ar[feature_title]`, this.data.feature_title_ar);
      submit_data.append(`en[feature_title]`, this.data.feature_title_en);
      submit_data.append(
        `ar[feature_description]`,
        this.data.feature_description_ar
      );
      submit_data.append(
        `en[feature_description]`,
        this.data.feature_description_en
      );

      this.data.main_features.forEach((feature, index) => {
        if (feature.icon.img_file) {
          submit_data.append(
            `main_features[${index}][icon]`,
            feature.icon.img_file
          );
        }
        if (feature.id) {
          submit_data.append(`main_features[${index}][id]`, feature.id);
        }
        submit_data.append(
          `main_features[${index}][ar][title]`,
          feature.title_ar
        );
        submit_data.append(
          `main_features[${index}][en][title]`,
          feature.title_en
        );
      });

      submit_data.append(
        `ar[project_done_description]`,
        this.data.project_done_description_ar
      );
      submit_data.append(
        `en[project_done_description]`,
        this.data.project_done_description_en
      );

      // this.data.project_provide_images.forEach((item, index) => {
      //   if( item.img_file){
      //       submit_data.append(`provide_images[${index}]`, item.img_file)
      //   }
      // })
      submit_data.append(
        `ar[project_provide_title]`,
        this.data.project_provide_title_ar
      );
      submit_data.append(
        `en[project_provide_title]`,
        this.data.project_provide_title_en
      );

      submit_data.append(
        `ar[project_provide_description]`,
        this.data.project_provide_description_ar
      );
      submit_data.append(
        `en[project_provide_description]`,
        this.data.project_provide_description_en
      );

      this.data.project_provide_features.forEach((feature, index) => {
        if (feature.icon.img_file) {
          submit_data.append(
            `project_provide_features[${index}][icon]`,
            feature.icon.img_file
          );
        }
        if (feature.id) {
          submit_data.append(
            `project_provide_features[${index}][id]`,
            feature.id
          );
        }
        submit_data.append(
          `project_provide_features[${index}][ar][title]`,
          feature.title_ar
        );
        submit_data.append(
          `project_provide_features[${index}][en][title]`,
          feature.title_en
        );
      });

      submit_data.append("_method", "PUT");
      this.axios({
        method: "POST",
        url: `project/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/projects" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // get Technologies
    getCategories() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: "project-categories-without-paginate",
      })
        .then((res) => {
          this.categories = res.data.data;
        })
        .catch(() => {});
    },
    getTools() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: "tools_without_pagination",
      })
        .then((res) => {
          this.tools = res.data.data;
        })
        .catch(() => {});
    },
    getData() {
      this.axios({
        method: "GET",
        url: `project/${this.id}`,
      })
        .then((res) => {
          this.data = res.data.data;
          (this.data.founded_in = this.manufactruingYears.find(
            (el) => el.name == res.data.data.founded_in
          )),
            // this.data.founded_in=res.data.data.founded_in
            (this.btnIsLoading = false);
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.$router.push({ path: "/projects" });
          this.btnIsLoading = false;
        });
    },
  },

  mounted() {
    this.getTools();
    this.getCategories();
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.img_dev {
  position: relative;
  z-index: 1;
  overflow: hidden;
  border-radius: 15px;
  width: fit-content;
  .button_delete {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #0007;
    display: none;
    * {
      color: #d40404;
      font-size: 27px !important;
    }
  }
  img {
    display: inline-block;
    width: 300px;
    height: 150px;
    border-radius: 10px;
    object-fit: contain;
    margin: auto;
  }
  &:hover {
    .button_delete {
      display: block;
      display: flex;
    }
  }
}
.product {
  .chooseImage {
    width: auto !important;
  }
}
.border_main_color {
  border: 1px solid var(--mainColor-2_2);
  padding-block: 30px;
  border-radius: 15px;
  margin-block: 15px;
  h3 {
    margin-block-end: 10px;
  }
}
.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
